export default "__VITE_ASSET__dMaEkoE4__"